<template>
	<form class="">
			<div class="flex items-center gap-x-3">
						<ui-button
							class="py-2 mt-1"
							:disabled="form.processing || subscription.deleted_at"
							v-on:click="submitForm()"
							:label="['UNAUTHORIZED', 'FAILED', 'CHARGED_BACK'].includes(subscription.payment_status) ? 'Abo entsperren' : 'Abo sperren'"
						/>
			</div>
	</form>
		</template>
<script>
import axios from "axios";
import Vue from "vue";
export default {
	props: {
		subscription: {
			type: Object,
			required: true,
		},
	},
	data() {

		const formData = {
			suspended: !['UNAUTHORIZED', 'FAILED', 'CHARGED_BACK'].includes(this.subscription.payment_status),
		};

		return {
			form: Vue.observable(this.$inertia.form(formData)),
		};
	},
	methods: {
		async submitForm() {
			const params = {};
			if (this.subscription) {
				params["id"] = this.subscription.id;
			}

			console.log(this.form);

			let promise = new Promise((resolve, reject) => {
				const response = axios.post(
					this.$route("admin.subscriptions.suspend", params),
					this.form
				);

				resolve(response);
				reject(response);
			});

			promise.then(
				(result) => this.onSuccess(result),
				(error) => this.onError(error)
			);
		},
		onSuccess(result) {
			window.location.reload();
		},
		onError(error) {

			console.log(error);

			if (error.response?.status) {
					const errors = error.response.data.errors;
					this.$bus.$emit("form:invalid", errors);
			}
		},
	},
};
</script>
